/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePropertyRequest
 */
export interface CreatePropertyRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePropertyRequest
     */
    streetAddress: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePropertyRequest
     */
    unit?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePropertyRequest
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePropertyRequest
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePropertyRequest
     */
    zipCode: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePropertyRequest
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePropertyRequest
     */
    notes?: string | null;
}

/**
 * Check if a given object implements the CreatePropertyRequest interface.
 */
export function instanceOfCreatePropertyRequest(value: object): value is CreatePropertyRequest {
    if (!('streetAddress' in value) || value['streetAddress'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    return true;
}

export function CreatePropertyRequestFromJSON(json: any): CreatePropertyRequest {
    return CreatePropertyRequestFromJSONTyped(json, false);
}

export function CreatePropertyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePropertyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'streetAddress': json['streetAddress'],
        'unit': json['unit'] == null ? undefined : json['unit'],
        'city': json['city'],
        'state': json['state'],
        'zipCode': json['zipCode'],
        'country': json['country'] == null ? undefined : json['country'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function CreatePropertyRequestToJSON(json: any): CreatePropertyRequest {
    return CreatePropertyRequestToJSONTyped(json, false);
}

export function CreatePropertyRequestToJSONTyped(value?: CreatePropertyRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'streetAddress': value['streetAddress'],
        'unit': value['unit'],
        'city': value['city'],
        'state': value['state'],
        'zipCode': value['zipCode'],
        'country': value['country'],
        'notes': value['notes'],
    };
}

